import React, { Component } from "react";

import { Message } from "semantic-ui-react";
import axios from "axios";
import { Menu, Segment, Sidebar } from "semantic-ui-react";
import ReactHTMLParser from "react-html-parser";
import { library } from "@fortawesome/fontawesome-svg-core";
import GraphOptionsBox from './GraphOptionsBox';
//import GraphOptionsBox1 from './GraphOptionsBox1';
import pagecontent from "../Helpers/VICContent";
import AboutModal from "../../GeoportalModal";
import BarChart from './BarChart'
import CChart_SM from "./CChart_SM"
import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";

import TreeNode from "./TreeNodeV2";
import MapView from "./MapViewV2";
import Chart from "./CChart_VIC";


import GradientChart from "./GradientChart";
import LineChart from "./LineChart";

import menus from "../Helpers/menus";



import file_heads from "../Helpers/file-heads";
import week_dates from "../Helpers/week-dates";
import domain from "../../domain";
import colors from "../../colors";
import layerMap from "../Helpers/layer-map";
import { Rnd } from "react-rnd";
import { FadeLoader } from "react-spinners";
// import reservoir_data from "./Reservoir";
// import tuc_reservoir_data from "./TUCReservoirs";
library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);
var moment = require("moment");
var _ = require("lodash");

// var authType='Basic'
// var username='NhpAdmin'
// var password='nhp@1234'
// var basicAuth = authType + btoa(username + ':' + password);
// axios.defaults.headers.common['Authorization']=basicAuth
const message123 = `   <p align="justify">
Description of terrestrial hydrological flux components in terms of their geographical distribution and chronological variation is useful for water resources management, drought/flood assessment and climate related research. </p>
<p align="justify"> Earth Observation (EO) data from multitude platforms are providing wide ranging datasets that are useful for creation of spatially distributed parameters appropriate for hydrological budgeting and modeling. </p>
<p align="justify">Macro-scale, process based hydrological (Variable Infiltration Capacity - VIC) model has been adopted for modelling water balance components at uniform grid level. VIC, a semi-distributed & physically based hydrological model, solves both the water balance and the energy balance (Liang X., 1994).</p>
<p align="justify">  Model computes evapotranspiration, surface runoff, soil moisture, base flow and energy fluxes at the predefined grid resolution (few km to hundred km).</p>`;
const units = {
  yAxis: {
    "Precipitation-Rainfall": "mm",
    "Precipitation-GPM Rainfall": "mm",
    "Soil Moisture-Root Zone Soil Moisture (0 - 50 cm)": "m³/m³",
    "Soil Moisture-Upper Soil Moisture (0 - 15 cm)": "m³/m³",
    "Soil Moisture-Lower Soil Moisture (15 - 50 cm)": "m³/m³",
    "Soil Moisture-Deep Soil Moisture (50 - 150 cm)": "m³/m³",
    // "Evapotranspiration-Potential Evapotranspiration":"et_potential",
    "Evapotranspiration-Actual Evapotranspiration": "mm",
    // "Evapotranspiration-Reference Crop Evapotranspiration":"et_ref_crop" ,
    // "Evapotranspiration-Evapotranspiration from Open Water Bodies":"et_open_water_body" ,
    "Runoff-#": "mm",
    "Forecast Surface Runoff-1": "mm",
    "Forecast Surface Runoff-2": "mm",
    "Forecast Surface Runoff-3": "mm",

  },
};
class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // New Properties
      vertical: true,
      smaititle:null,

      weeklabels: null,
      weekcategories: null,
      weekseries: null,
      weekchartvisible: false,
      weekselected: '#',
      weekyears: null,
      weekyearselected: '#',
      weeks: null,
      weekvalue: '',
      smaiweeklayer: '',
      date:null,
      monthlabels: null,
      monthcategories: null,
      monthseries: null,
      monthchartvisible: false,
      monthselected: '#',
      monthyears: null,
      monthyearselected: '#',
      months: null,
      monthvalue: '',
      smaimonthlayer: '',
      dates_hist:[],
      flow_hist:[],
      month_monthlyAvg:[],
      flow_monthlyAvg:[],
      month_dailyAvg:[],
      flow_dailyAvg:[],
      dates_dailyAvg:[],
      prob_flowDur:[],
      flow_flowDur:[],
      year_returnPer:[],
      flow_returnPer:[],

      weekly: false,
      monthly: false,
      
      units_u: null,
      tabs: menus.mapSideBar,
      //width: 900,
      width: Math.min(800,  window.innerWidth * 0.9) , // Limit width to 800px max

      height: Math.min(420, window.innerHeight * 0.9), // Limit width to 800px max
      //height: 420,
      // x: 400,
      // y: window.innerHeight - 300 - 160,
      x: (window.innerWidth - 270 - 800) / 2,
      y_smai: window.innerHeight - 760,
      y: window.innerHeight - 700,
      width_p: 420,
      height_p: 600,
      x_p: 0,
      y_p: 20,
      pdffile: null,
      india_states_boundary: null,
      selectedMenu: null,
      // selectedMaps:null,
      // lastSelected:null,
      reservoir_date: null,
      pointInfo: null,
      legend: null,
      selectedLayer: {},
      visible: true,
      modal: true,
      date: "",
      layerExist: true,
      wms_url_base_layers: `${domain.Geoserver}geoserver/base-layers/wms`,
      wms_url_default: `${domain.Geoserver}geoserver/evapotranspiration/wms`,
      latlng: { lat: null, lng: null },
      visibleGraphPanel: false,

      reservoirname: null,
      reservoirHistname:null,
      reservoirLongdailyname:null,
      reservoirLongMonthname:null,
      reservoirFlowname:null,

      rchartData: null,

      availableDates: [],
      selectedNodeStaus: {},
      noGraph: {},
      slideTracker: -1,
      chartData: null,
      onClickDetails: {},
      stateInfo: null,
      graphLoader: true,
      showInfo: false,
      popupMenuSelected: {},
      popupMenuSelectedLast: null,
      popupMenuActive: false,
      datepickerenable: false,
      popupmenuName: null,
      geojsondata: null,
      chartloading: true,
      datesloading: true,
      legendVisible: true,
      visibleGraphPanel_pie: false,
      clickcount: 0,
      reservoirkey: 0
      // defaultDate:''
      // isDialogOpen: false
    };
    this.makeChartDataAvailableDays = this.makeChartDataAvailableDays.bind(
      this
    );
  }

  getChartHeight = (main) => {
    if (main === "smai-weekly" || main === "smai-monthly") {
      return this.state.height_smai;
    } else {
      return this.state.height;
    }
  };

  getChartY = (main) => {
    if (main === "smai-weekly" || main === "smai-monthly") {
      return this.state.y_smai;
    } else {
      return this.state.y;
    }
  };
  handleResize = () => {
    this.setState({
      width: Math.min(800,  window.innerWidth * 0.9),
      height: Math.min(420, window.innerHeight * 0.9),
    });
  };

  /** Tab Related */
  handleTabClick = (id) => {
    this.setState({
      tabs: this.updateTabs(id),
      visibleGraphPanel: false,
      showInfo: false,
      latlng: null,
    });
  };

  updateTabs = (id) => {
    console.log(id);
    let tabs = this.state.tabs;
    //   if()
    let newtabs = tabs.map((tab, index) => {
      if (tab.id === id) {
        if (tab.active === true) {
          tab.active = false;
        } else {
          tab.active = true;
        }
      } else {
        tab.active = false;
      }
      return tab;
    });
    console.log(newtabs);
    return newtabs;
  };

  incrementCounter = () => {
    this.setState({
      clickcount: this.state.clickcount + 1,
    });
  };


  toggleVisibleGraphPanel = () => {
    if (this.state.chartData !== null || this.state.rchartData !== null || this.state.weekseries!==null || this.state.monthseries!==null) {
      this.setState({
        visibleGraphPanel: !this.state.visibleGraphPanel,
        technicalnoteenable: false,
        disclaimerenable: false,
        popupMenuActive: false
      });
    }
  };

  toggleVisibleGraphPanel_pie = () => {
    if (this.state.popup !== null) {
      this.setState({
        visibleGraphPanel_pie: !this.state.visibleGraphPanel_pie,
        technicalnoteenable: false,
        disclaimerenable: false,
        popupMenuActive: false
      });
    }
  };

  handleVisibleGraphPanelOnMapClick_NoGraph = () => {
    this.setState({
      visibleGraphPanel: false,
    });
  };

  handleVisibleGraphPanelOnMapClick = () => {
    // console.log(this.state.popupmenuName)

    this.setState({
      visibleGraphPanel: true,
    });
  };

  menuSelected = (menu) => {
    console.log(menu);
    this.setState({
      popupmenuName: menu,
    });
  };

  /** Toggle Selected Node (true) */

  toggleSelectedNodeStatus = (menu) => {
    console.log('Menu', menu);
    console.log('Menu1', { ...this.state.selectedNodeStatus });
    let selectedNodeStaus = { ...this.state.selectedNodeStatus };

    console.log('Menu2', selectedNodeStaus);
    selectedNodeStaus[menu] = !selectedNodeStaus[menu];

    console.log('Menu3', selectedNodeStaus);

    this.setState({
      selectedNodeStaus: selectedNodeStaus,
    });
  };

  setNoGraph = (menu, status) => {
    let noGraph = { ...this.state.noGraph };
    noGraph[menu] = status;

    this.setState({
      noGraph: noGraph,
      // visibleGraphPanel:false
    });
  };
  disableDatePicker = (status) => {
    this.setState({
      datepickerenable: status,
    });
  };

  handleAnimationChange = () => {
    this.setState({
      visible: !this.state.visible,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  handleWeekChange = (e) => {
    if (e.target.value !== '#') {

      this.setState({
        weekvalue: e.target.value
      })
    }
  }

  handleMonthChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        monthvalue: e.target.value
      })
    }
  }

  toggleWeekChart = () => {
    this.setState({
      weekchartvisible: !this.state.weekchartvisible
    })
  }

  toggleMonthChart = () => {
    this.setState({
      monthchartvisible: !this.state.monthchartvisible
    })
  }

  /** Method for selection of menu item */

  setSelectedMenu = (menu) => {
    if (menu) {
      if (menu.split("-")[1] === 'weekly') {
        this.getAvailableDates_weekly()
        this.setState({
          weekly: true,
          monthly: false
        })
      }
      else if (menu.split("-")[1] === 'monthly') {
        this.getAvailableDates_monthly()
        this.setState({
          weekly: false,
          monthly: true
        })
      }
    }

    this.setState({
      selectedMenu: menu,
      chartData: null,
      latlng: null,
      legendVisible: true,
      visibleGraphPanel: false,
      visibleGraphPanel_pie: false,
      rchartData: null,
      showInfo: false,
      clickcount: this.state.clickcount + 1,
      // lastSelected: menu
    });
    this.getIndiaStatesBoundary();

  };



  togglePopupMenuSelected = (menu) => {
    console.log(menu);
    let popupMenuSelected = { ...this.state.popupMenuSelected };
    popupMenuSelected[menu] = !popupMenuSelected[menu];
    this.setState({
      popupMenuSelected: popupMenuSelected,

    });
  };

//onclick point file over map
  setGeoJson = async (menu) => {
    console.log(menu.split("-")[1])
    if (menu.split("-")[1] === 'tuc') {
      let result = await axios.get(`${domain.DBServer}/fetch-reservoir-vic-as`)
      if (result) {
        this.setState({
          geojsondata: result.data[0].boundary,
          visibleGraphPanel: false,
          reservoirkey: 1
        });
      }
    }
    else {
      let result = await axios.get(`${domain.DBServer}/fetch-reservoir-vic`)
      if (result) {
        this.setState({
          geojsondata: result.data[0].boundary,
          visibleGraphPanel: false,
          reservoirkey: 2
        });
      }

    }

  };

  setPopupMenuStatusOnMapMenuClick = () => {
    this.setState({
      popupMenuActive: false,
    });
  };

  setPopupMenuSelectedStatus = () => {
    this.setState({
      popupMenuActive: !this.state.popupMenuActive,
    });
  };

  setPopupMenuSelectedLast = (menu) => {
    this.setState({
      popupMenuSelectedLast: menu,
    });
  };

  toggleShowInfo = () => {
    this.setState({ showInfo: !this.state.showInfo });
  };

  showInfoOnMapClick = () => {
    this.setState({ showInfo: true });
  };
  
  /** Method for defining Layer name  */
  setSelectedLayer = (main) => {
    console.log(main);
    console.log(this.state.weekyearselected, this.state.weekselected)
    let selectedLayer = { ...this.state.selectedLayer };

    if (
      new URLSearchParams(this.props.location.search).get("date") &&
      selectedLayer[main] === undefined
    ) {
      selectedLayer[main] =
        file_heads +
        moment(
          new URLSearchParams(this.props.location.search).get("date"),
          "DD-MM-YYYY"
        ).format("YYYYMMDD");
    }
    else if (main === 'smai-weekly') {
      // selectedLayer[main] = file_heads + "Y" + this.state.weekyearselected + "_" + this.state.weekselected
      selectedLayer[main] = this.state.smaiweeklayer
    }
    else if (main === 'smai-monthly') {
      // selectedLayer[main] = file_heads + "Y" + this.state.monthyearselected + "_" + this.state.monthselected
      selectedLayer[main] = this.state.smaimonthlayer
    }
    else {

      selectedLayer[main] = moment.isMoment(this.state.date)
        ? file_heads + this.state.date.format("YYYYMMDD")
        : file_heads + moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
    }


    console.log(123)
    console.log(123)
    console.log(123)
    console.log(selectedLayer)

    this.setState({
      selectedLayer: selectedLayer,
    });
  };
  //  componentWillUnmount()
  //  {
  //    this.handleTabClick(1)
  //  }
  setStateInfo = (info) => {
    this.setState({
      stateInfo: info,
    });
  };

  setForeCastDate = (date) => {
    this.setState({
      forecastDate: date,
    });
  };

  setLegend = (src) => {
    this.setState({
      legend: src,
    });
  };

  setLatLng = (latlng) => {
    this.setState({
      latlng: latlng,
    });
  };

  setOnClickDetails = (data) => {
    this.setState({
      onClickDetails: data,
    });
  };

  emptyChartData = () => {
    this.setState({
      reservoirname: null,
      rchartData: null,
      reservoirHistname:null,
      reservoirLongdailyname:null,
      reservoirLongMonthname:null,
      reservoirFlowname:null,
      visibleGraphPanel: false
    })
  }

  getWeeksByYear = async (maxyear) => {
    let result1 = await axios.get(`${domain.DBServer}/fetch-smai-weekly-year-weeks/${maxyear}`)
    if (result1) {

      this.setState({
        
        weekyearselected: maxyear,
        weeks: result1.data,
        weekselected: '#'
      })
    }
  }

  getMonthsByYear = async (maxyear) => {
    let result1 = await axios.get(`${domain.DBServer}/fetch-smai-monthly-year-months/${maxyear}`)
    if (result1) {

      this.setState({
        monthyearselected: maxyear,
        months: result1.data,
        monthselected: '#'
      })
    }
  }

  getAvailableDates_weekly = async () => {
    let result = await axios.get(`${domain.DBServer}/fetch-smai-weekly-years`)
    if (result) {
      if (result.data) {
        console.log(result.data)
        let maxyear = Math.max.apply(Math, result.data.map(function (o) {
          return Number(o.year);
        }));

        this.getWeeksByYear(maxyear)
        this.setState({
          weekyears: result.data,
        })
      }
    }
  }

  getAvailableDates_monthly = async () => {
    let result = await axios.get(`${domain.DBServer}/fetch-smai-monthly-years`)
    if (result) {
      if (result.data) {
        console.log(result.data)
        let maxyear = Math.max.apply(Math, result.data.map(function (o) {
          return Number(o.year);
        }));

        this.getMonthsByYear(maxyear)
        this.setState({
          monthyears: result.data,
        })
      }
    }
  }



  weekYearChange = (e) => {
    if (e.target.value !== '#') {
      this.getWeeksByYear(e.target.value)
      this.setState({
        weekyearselected: e.target.value
      })
    }
  }

  monthYearChange = (e) => {
    if (e.target.value !== '#') {
      this.getMonthsByYear(e.target.value)
      this.setState({
        monthyearselected: e.target.value
      })
    }
  }

  fillObject = (data) => {
    let obj = data.reduce((res, item) => ({ ...res, ...item }));
    console.log(obj)
    let keys = Object.keys(obj)

    let def = keys.reduce((result, key) => {
      result[key] = 0
      return result;
    }, {});
    let result = data.map((item) => ({ ...def, ...item }));
    console.log(result);
  }

  getWeekChartData = async (week) => {
    let result = await axios.get(`${domain.DBServer}/fetch-smai-weekly-stats/${this.state.weekyearselected}/${week}`)
    if (result) {

      if (result.data) {
        var weeklayer1 = result.data[0].filename;

        // this.fillObject(result.data)
        var groupBy = function (xs, key) {
          return xs.reduce(function (rv, x) {

            (rv[x[key]] = rv[x[key]] || []).push(Number(x.count).toFixed(2));
            return rv;
          }, {});
        };


        const unique = [...new Set(result.data.map(item => item.range_min))];
        let newarray = []
        result.data.map((item) => {

          for (let i = 0; i < unique.length; i++) {

            if (unique[i] === item.range_min) {
              newarray.push(item)
            }
            else {
              let name = item.state
              let find1 = result.data.filter((item) => (item.state === name && item.range_min === unique[i]))
              let find = newarray.filter((item) => (item.state === name && item.range_min === unique[i]))
              console.log(find.length, name)
              if (find.length === 0 && find1.length === 0) {
                newarray.push({
                  ...item,
                  count: 0,
                  range_min: unique[i]
                })
              }
            }
          }
        })
        // console.log(newarray)
        let newseries = groupBy(newarray, 'range_min')
        let categories = [...new Set(result.data.map((item) => item.state))]
        let labels = [...new Set(result.data.map((item) => item.range_min))]
        // console.log(categories)
        const map = new Map(Object.entries(newseries));
        let jsonseries = []
        map.forEach((value, key) => {
          jsonseries.push({
            name: key,
            data: value
          })
        })

        // console.log(111);
        // console.log(111);

        // var fdate = moment().day("Monday").year(this.state.weekyearselected).week(this.state.weekselected.substring(1)).toDate();
        // var ldate = moment().day("Sunday").year(this.state.weekyearselected).week(this.state.weekselected.substring(1)).toDate();

        // console.log(111);
        // console.log(111);
        // console.log(fdate);
        // console.log(ldate);

        // console.log(jsonseries)
        this.setState({
          smaititle:`SMAI ${this.state.weekyearselected} - ${this.state.weekselected} (${week_dates[this.state.weekselected]})`,
          smaiweeklayer: weeklayer1.split(".")[0],
          vertical: true,
          visibleGraphPanel: true,
          weekseries: jsonseries,
          weekcategories: categories,
          weeklabels: labels
        })

        this.setSelectedLayer(this.state.selectedMenu);
        


      }
    }
  }

  getMonthChartData = async (month) => {
    let result = await axios.get(`${domain.DBServer}/fetch-smai-monthly-stats/${this.state.monthyearselected}/${month}`)
    if (result) {

      if (result.data) {
        // console.log(result.data)
        // this.fillObject(result.data)
        var monthlayer1 = result.data[0].filename;

        var groupBy = function (xs, key) {
          return xs.reduce(function (rv, x) {

            (rv[x[key]] = rv[x[key]] || []).push(Number(x.count).toFixed(2));
            return rv;
          }, {});
        };


        const unique = [...new Set(result.data.map(item => item.range_min))];
        console.log(unique)
        console.log(unique)
        let newarray = []
        result.data.map((item) => {

          for (let i = 0; i < unique.length; i++) {

            if (unique[i] === item.range_min) {
              newarray.push(item)
            }
            else {
              let name = item.state
              let find1 = result.data.filter((item) => (item.state === name && item.range_min === unique[i]))
              let find = newarray.filter((item) => (item.state === name && item.range_min === unique[i]))
              console.log(find.length, name)
              if (find.length === 0 && find1.length === 0) {
                newarray.push({
                  ...item,
                  count: 0,
                  range_min: unique[i]
                })
              }
            }
          }
        })
        console.log(newarray)
        let newseries = groupBy(newarray, 'range_min')
        let categories = [...new Set(result.data.map((item) => item.state))]
        let labels = [...new Set(result.data.map((item) => item.range_min))]
        console.log(categories)
        const map = new Map(Object.entries(newseries));
        let jsonseries = []
        map.forEach((value, key) => {
          jsonseries.push({
            name: key,
            data: value
          })
        })

        console.log(jsonseries)
        this.setState({
          smaititle:`SMAI ${this.state.monthyearselected} - ${this.state.monthselected}`,
          smaimonthlayer: monthlayer1.split(".")[0],
          vertical: true,
          visibleGraphPanel: true,
          weekseries: jsonseries,
          weekcategories: categories,
          weeklabels: labels
        })

        this.setSelectedLayer(this.state.selectedMenu);


      }
    }
  }

  setWeeklyData = (data,value) => {
    this.setState({
      vertical: false,
      visibleGraphPanel: false,
      weekseries: null,
      weekcategories: null,
      weeklabels: null
    })

    var groupBy = function (xs, key) {
      return xs.reduce(function (rv, x) {

        (rv[x[key]] = rv[x[key]] || []).push(Number(x.count).toFixed(2));
        return rv;
      }, {});
    };
    let newseries = groupBy(data, 'range_min')
    let categories = [...new Set(data.map((item) => item.week))]
    let labels = [...new Set(data.map((item) => item.range_min))]
    let jsonseries = []
    const map = new Map(Object.entries(newseries));

    map.forEach((value, key) => {
      jsonseries.push({
        name: key,
        data: value
      })
    })
    this.setState({    
            smaititle:`SMAI ${this.state.weekyearselected} - ${value}`,

      vertical: false,
      visibleGraphPanel: true,
      weekseries: jsonseries,
      weekcategories: categories,
      weeklabels: labels
    })

  }

  setMonthlyData = (data,value) => {
    this.setState({
      vertical: false,
      visibleGraphPanel: false,
      monthseries: null,
      monthcategories: null,
      monthlabels: null
    })

    var groupBy = function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(Number(x.count).toFixed(2));
        return rv;
      }, {});
    };
    let newseries = groupBy(data, 'range_min')
    let categories = [...new Set(data.map((item) => item.week))]
    let labels = [...new Set(data.map((item) => item.range_min))]
    let jsonseries = []
    const map = new Map(Object.entries(newseries));

    map.forEach((value, key) => {
      jsonseries.push({
        name: key,
        data: value
      })
    })
    this.setState({    
            smaititle:`SMAI ${this.state.monthyearselected} - ${value}`,

      vertical: false,
      visibleGraphPanel: true,
      weekseries: jsonseries,
      weekcategories: categories,
      weeklabels: labels
    })

  }


  weekChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        visibleGraphPanel: false,
        weekseries: null,
        weekcategories: null
      })
      this.getWeekChartData(e.target.value)
      this.setState({
        weekselected: e.target.value
      })
    }
  }

  monthChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        visibleGraphPanel: false,
        monthseries: null,
        monthcategories: null
      })
      this.getMonthChartData(e.target.value)
      this.setState({
        monthselected: e.target.value
      })
    }
  }
setloading_fun=(value)=>{
  this.setState({
    chartloading:value,
  })
}

  setGradientContent = (p, name, date, chartData,dates_hist,flow_hist,month_monthlyAvg,flow_monthlyAvg,dates_dailyAvg,flow_dailyAvg,month_dailyAvg,prob_flowDur,flow_flowDur,year_returnPer,flow_returnPer,loadvalue) => {
    
    
    let combinedLabels=[],month_list=[],days=30,count=0;
   
    function removeDuplicates(arr) {
      return arr.filter((item,
          index) => arr.indexOf(item) === index);
      }

month_list=removeDuplicates(month_dailyAvg);


for (let i = 0; i < month_list.length; i++ ) {

      //console.log("i",month_list[i],i)
      //console.log("mmmmmmmmmmonth_list",month_list[i])
      let var1=[ 'July     ', 'August   ', 'October  ', 'December '].includes(month_list[i])
     // console.log("varrr1",var1)

      let var2=['June     ', 'September','November '].includes(month_list[i])
      //console.log("varrr2",var2)
      if (var1)
      {
     // console.log("mmmmmmmmmmmnnnnn31nnnnnnn")
      days=31
      }else if( var2) {
      //console.log("mmmmmmmm30")
      days=30
      }

console.log("date_daily",dates_dailyAvg,days,month_dailyAvg[count])
      for (let j=0; j<days;j++) {
        //console.log("j",j,dates_dailyAvg[count])
        let monthname=month_list[i].trim()
        monthname=monthname.slice(0,3)

      combinedLabels.push(`${dates_dailyAvg[count]}-${monthname}`);
      count=count+1
      }
  
}
let today_date = new Date().toJSON().slice(0, 10);
   // name=name.replace(/\(|\)/g, "-").replace(/-$/, " ");
//console.log("combined",combinedLabels,combinedLabels.length)

    this.setState({
      // position: p,
      visibleGraphPanel: true,
      /*
      reservoirname:
     
        ["Current Year Simulated Inflow ","("+
        name +
      ")"],

      reservoirHistname:

       [ "Last 10 Year Simulated Inflow","("+
        name +")" ],

      reservoirLongdailyname:

        ["Long Term Daily Average Inflow" ,"("+
        name +")" ] ,

      reservoirLongMonthname:
        [ "Long Term Monthly Average Inflow ","("+
        name +")" ],

      reservoirFlowname:
        ["Flow Duration Curve ","("+
        name +")"  ],
        */

//===================edited 13-sept-2023
reservoirname:
     
["Current Year Simulated Inflow ",
name],

reservoirHistname:

[ "Last 10 Year Simulated Inflow",
name ],

reservoirLongdailyname:

["Long Term Daily Average Inflow" ,
name ] ,

reservoirLongMonthname:
[ "Long Term Monthly Average Inflow ",
name ],

reservoirFlowname:
["Flow Duration Curve ",
name ],


      reservoir_date: date,
      rchartData: chartData,
      popupMenuActive: false,
      flow_hist:flow_hist,
      dates_hist:dates_hist,
      month_monthlyAvg:month_monthlyAvg,
      flow_monthlyAvg:flow_monthlyAvg,
      dates_dailyAvg:combinedLabels,
      //month_dailyAvg:month_dailyAvg,
      flow_dailyAvg:flow_dailyAvg,
      prob_flowDur:prob_flowDur,
      flow_flowDur:flow_flowDur,
      year_returnPer: year_returnPer,
      flow_returnPer:flow_returnPer,
      date:today_date,
      chartloading:false,

 

    });
    

   // console.log("aaaaaaaaaaaaaaaaaaareturnaaaaaaa",this.state.flow_returnPer,combinedLabels)
  };

  
  async makeChartDataAvailableDays() {

    console.log(layerMap[this.state.selectedMenu].split("_")[0])
    if (this.state.latlng.lat && this.state.latlng.lng && layerMap[this.state.selectedMenu].split("_")[0] !== 'SMAI') {
      this.setState({ chartloading: true, chartData: null, rchartData: null,  weekseries: null,
        weekcategories: null, });
      console.log(layerMap[this.state.selectedMenu].split("_")[0]);
      if (layerMap[this.state.selectedMenu].split("_")[0] !== "FSRO") {
        let result = await axios({
          method: "post",
          url: `${domain.DBServer}/get-pixel-value-vic-${
            layerMap[this.state.selectedMenu]
            }`,
          data: {
            lat: this.state.latlng.lat,
            lon: this.state.latlng.lng,
            selected: layerMap[this.state.selectedMenu],
            file: this.state.selectedLayer[
              this.state.selectedMenu
            ].toUpperCase(),
          },
        });
        if (result) {
          let activeDate = moment.isMoment(this.state.date)
            ? this.state.date.format("YYYYMMDD")
            : moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
          let title = this.state.selectedMenu
            ? this.state.selectedMenu.split("-")[0]
            : null;
          console.log(title);

          if (result.data) {
            let chartData = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              let date = regex.exec(item.filename)[0];
              let chartDate = moment(date);
              console.log(item.pixel_val);
              if (activeDate === date) {
                console.log(item.pixel_val);
                this.setState({
                  showInfo: true,
                  pointInfo: Number(item.pixel_val).toFixed(3),
                });
              }
              if (item.pixel_val !== null) {
                return [
                  Date.UTC(
                    parseInt(chartDate.format("YYYY"), 10),
                    parseInt(chartDate.format("MM"), 10) - 1,
                    parseInt(chartDate.format("DD"), 10)
                  ),
                  item.pixel_val,
                ];
              } else {
                return [
                  Date.UTC(
                    parseInt(chartDate.format("YYYY"), 10),
                    parseInt(chartDate.format("MM"), 10) - 1,
                    parseInt(chartDate.format("DD"), 10)
                  ),
                  null,
                ];
              }
            });

            var dates = chartData.map(function (x) {
              return new Date(x[0]);
            });
            console.log(dates);
            this.setState({
              graphLoader: false,
              chartData: {
                seriesData: chartData,

                title: title,
                name: title,
                type: "bar",
                maximumDate: new Date(Math.max.apply(null, dates)),
                minimumDate: new Date(Math.min.apply(null, dates)),
                yAxisTitle:
                  title +
                  " (" +
                  ReactHTMLParser(units.yAxis[this.state.selectedMenu]) +
                  ")",
                units: units.yAxis[this.state.selectedMenu],
              },
              chartloading: false,
              showInfo: true,
              units_u: units.yAxis[this.state.selectedMenu],
            });
          }
        }
      } 
      else {
        console.log("KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK")
        let d = moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
        console.log(d);
        let result = await axios({
          method: "post",
          url: `${domain.DBServer}/get-pixel-value-vic-${
            layerMap[this.state.selectedMenu].split("_")[0]
            }`,
          data: {
            lat: this.state.latlng.lat,
            lon: this.state.latlng.lng,
            date: d,
            selected: layerMap[this.state.selectedMenu],
            file: this.state.selectedLayer[
              this.state.selectedMenu
            ].toUpperCase(),
          },
        });
        if (result) {
          let activeDate = moment.isMoment(this.state.date)
            ? this.state.date.format("YYYYMMDD")
            : moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
          // let chartDate
          if (result.data) {
            // let title=this.state.selectedMenu?this.state.selectedMenu.split("-")[0]:null
            let chartData = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              let date = regex.exec(item.filename)[0];
              let dd = item.filename.split("_")[1];
              console.log(dd);

              console.log(
                moment(date, "YYYYMMDD").add(2, "days").format("YYYYMMDD")
              );

              let chartDate =
                dd === "1"
                  ? moment(activeDate, "YYYYMMDD")
                    .add(0, "days")
                    .format("YYYYMMDD")
                  : dd === "2"
                    ? moment(activeDate, "YYYYMMDD")
                      .add(1, "days")
                      .format("YYYYMMDD")
                    : dd === "3"
                      ? moment(activeDate, "YYYYMMDD")
                        .add(2, "days")
                        .format("YYYYMMDD")
                      : null;

              let cdate = moment(chartDate);
              if (
                layerMap[this.state.selectedMenu].split("_")[1] ===
                item.filename.split("_")[1]
              ) {
                console.log(item.pixel_val);
                this.setState({
                  showInfo: true,
                  pointInfo: item.pixel_val,
                });
              }
              if (item.pixel_val !== null) {
                return [
                  Date.UTC(
                    parseInt(cdate.format("YYYY"), 10),
                    parseInt(cdate.format("MM"), 10) - 1,
                    parseInt(cdate.format("DD"), 10)
                  ),
                  item.pixel_val,
                ];
              }

              return true;
            });
            chartData.sort();
            chartData = Array.from(
              new Set(chartData.map(JSON.stringify)),
              JSON.parse
            );

            console.log(chartData);
            dates = chartData.map(function (x) {
              return new Date(x[0]);
            });
            console.log(dates);
            this.setState({
              graphLoader: false,
              chartData: {
                seriesData: chartData,
                title: "Forecast Surface Runoff",
                name: "Forecast Surface Runoff",

                type: "line",
                maximumDate: new Date(Math.max.apply(null, dates)),
                minimumDate: new Date(Math.min.apply(null, dates)),
                yAxisTitle:
                  "Forecast Surface Runoff (" +
                  ReactHTMLParser(units.yAxis[this.state.selectedMenu]) +
                  ")",
                units: units.yAxis[this.state.selectedMenu],
                // xAxisTitle:'Days'
              },
              chartloading: false,
              showInfo: true,
              units_u: units.yAxis[this.state.selectedMenu],
            });
          }
        }
      }
    }
  }

  // getAvailableDates_custom = (type) => {
  //   // let availableDates = [...this.state.availableDates]
  //   // let availableDates=[]
  //   // console.log(availableDates)
  //   this.setState({ datesloading: true });
  //   axios
  //     .request({
  //       method: "post",
  //       url: `${domain.DBServer}/get-avail-dates-vic-${type}`,
  //       data: {},
  //     })
  //     .then((result) => {
  //       // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
  //       if (result) {
  //         if (result.data) {
  //           console.log(result.data);
  //           const years = result.data.map((item) => {
  //             let regex = /\d{4}/;
  //             // console.log(item.file_name.match(regex))
  //             let year = regex.exec(item.filename)[0];
  //             // availableDates.push(moment(date))
  //             return(year)
  //           });
  //           //    console.log(ad)

  //           // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
  //           let maxdate = Math.max(years)

  //           this.setState({
  //           //  availableDates: sortedDates,
  //            // date: maxdate,
  //             //slideTracker: sortedDates.length - 1,
  //             // selectedLayer:selectedLayer,
  //             //datesloading: false,
  //             smaiyears:years,
  //             smaiweeks:weeks,
  //             maxweek:
  //           });
  //         }
  //       }
  //     });

  //   // let sortedDates = availableDates.sort(function (left, right) {
  //   //     return moment.utc(left.timeStamp).diff(moment.utc(right.timeStamp))
  //   // });
  // };
  getAvailableDates = () => {
    // let availableDates = [...this.state.availableDates]
    // let availableDates=[]
    // console.log(availableDates)
    this.setState({ datesloading: true });
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-vic`,
        data: {},
      })
      .then((result) => {
        // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
        if (result) {
          if (result.data) {
            console.log(result.data);
            const availableDates = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              // console.log(item.file_name.match(regex))
              let date = regex.exec(item.filename)[0];
              // availableDates.push(moment(date))
              return moment(date);
            });
            //    console.log(ad)

            // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
            let maxdate = moment.max(availableDates);
            console.log(maxdate);
            let sortedDates = _.sortBy(availableDates, (d) => {
              // console.log(d)
              return new moment(d);
            });
            console.log(sortedDates);
            this.setState({
              availableDates: sortedDates,
              date: maxdate,
              slideTracker: sortedDates.length - 1,
              // selectedLayer:selectedLayer,
              datesloading: false,
            });
          }
        }
      });

    // let sortedDates = availableDates.sort(function (left, right) {
    //     return moment.utc(left.timeStamp).diff(moment.utc(right.timeStamp))
    // });
  };

  getAvailableDates_url = () => {
    // let availableDates = [...this.state.availableDates]
    // let availableDates=[]
    // console.log(availableDates)
    this.setState({ datesloading: true });
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-vic-FSRO`,
        data: {},
      })
      .then((result) => {
        // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
        if (result) {
          if (result.data) {
            console.log(result.data);
            const availableDates = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              // console.log(item.file_name.match(regex))
              let date = regex.exec(item.filename)[0];
              // availableDates.push(moment(date))
              return moment(date);
            });
            //    console.log(ad)

            // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
            let maxdate = moment.max(availableDates);
            console.log(maxdate);
            let sortedDates = _.sortBy(availableDates, (d) => {
              // console.log(d)
              return new moment(d);
            });
            console.log(sortedDates);
            this.setState({
              availableDates: sortedDates,
              date: maxdate,
              slideTracker: sortedDates.length - 1,
              // selectedLayer:selectedLayer,
              datesloading: false,
            });
          }
        }
      });

    // let sortedDates = availableDates.sort(function (left, right) {
    //     return moment.utc(left.timeStamp).diff(moment.utc(right.timeStamp))
    // });
  };

  handleDateChange = (event, { name, value }) => {
    let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let availableDates = [...this.state.availableDates];
    let availableDatesStr = availableDates.map((date) => {
      return moment(date, "DD-MM-YYYY").format("YYYYMMDD");
    });

    // selectedLayer["Evapotranspiration"]=et_file_head+selected_date
    // selectedLayer["Soil Heat Flux"]=dshf_file_head+selected_date
    // selectedLayer["Net Radiation"]=dnr_file_head+selected_date

    if (this.state.selectedMenu.split("-")[0] === "Forecast Surface Runoff") {
      this.toggleSelectedNodeStatus();
    }
    selectedLayer[this.state.selectedMenu] = file_heads + selected_date;

    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,
        selectedLayer: selectedLayer,
        slideTracker: availableDatesStr.indexOf(selected_date),
        layerExist: true,
        chartData: null,
        visibleGraphPanel: false,
        latlng: null,
        showInfo: false,
      });
    }
  };

  onSlide = (event) => {
    event.preventDefault();
    let value = parseInt(event.target.value, 10);

    let selected_date = moment(
      this.state.availableDates[value],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };

    let menu = this.state.selectedMenu;
    // Object.keys(file_heads).forEach((menu)=>{
    selectedLayer[menu] = file_heads + selected_date;
    // })

    this.setState({
      slideTracker: value,
      date: this.state.availableDates[value],
      selectedLayer: selectedLayer,
      chartData: null,
      visibleGraphPanel: false,
      latlng: null,
      showInfo: false,
    });
  };

  onClickSlideLeft = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker > 0) {
      slideTracker = slideTracker - 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };

    let menu = this.state.selectedMenu;
    // Object.keys(file_heads).forEach((menu)=>{
    selectedLayer[menu] = file_heads + selected_date;
    // })

    this.setState({
      slideTracker: slideTracker,
      date: this.state.availableDates[slideTracker],
      selectedLayer: selectedLayer,
      chartData: null,
      visibleGraphPanel: false,
      latlng: null,
      showInfo: false,
    });
  };

  onClickSlideRight = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker < this.state.availableDates.length - 1) {
      slideTracker = slideTracker + 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_heads).forEach((menu)=>{
    selectedLayer[menu] = file_heads + selected_date;
    // })

    this.setState({
      slideTracker: slideTracker,
      date: this.state.availableDates[slideTracker],
      selectedLayer: selectedLayer,
      chartData: null,
      visibleGraphPanel: false,
      latlng: null,
      showInfo: false,
    });
  };

  getIndiaStatesBoundary = () => {
    axios.post(`${domain.DBServer}/get-india-states-boundary`).then((result) => {
      if (result) {
        this.setState({
          india_states_boundary: result.data[0].india_boundary,
        });
      }
    });
  };

  getAvailableDates_date = () => {
    this.setState({ datesloading: true });
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-vic`,
        data: {},
      })
      .then((result) => {
        // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
        if (result) {
          if (result.data) {
            console.log(result.data);
            const availableDates = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              // console.log(item.file_name.match(regex))
              let date = regex.exec(item.filename)[0];
              // availableDates.push(moment(date))
              return moment(date);
            });
            //    console.log(ad)

            // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
            let maxdate = moment.max(availableDates);
            console.log(maxdate);
            let sortedDates = _.sortBy(availableDates, (d) => {
              // console.log(d)
              return new moment(d);
            });
            console.log(this.state.date);
            console.log(maxdate);
            this.setState({
              availableDates: sortedDates,
              date: this.state.date > maxdate ? maxdate : this.state.date,
              slideTracker: this.state.date > maxdate ? sortedDates.length - 1 : this.state.slideTracker,
              // selectedLayer:selectedLayer,
              datesloading: false,
            });
          }
        }
      });

  }



  getTechnicalNote = () => {
    axios.get(`${domain.DBServer}/fetch-technicalnote/VIC`).then((res) => {
      if (res) {
        this.setState({
          pdffile: `${domain.DBServer}` + res.data[0].file
        })
      }
    }

    )

  }



  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.getAvailableDates();
    this.getTechnicalNote()
    if (window.innerWidth > 300 && window.innerWidth < 1000) {
      this.setState({
        visible: false,
        legendVisible: false,
        x: 0,
        y: 0,
        width: 300,
        height: 300

      })
    }
    else if (window.innerWidth >= 1000 && window.innerWidth < 1100) {
      this.setState({
        visible: false,
        legendVisible: false,
        x: 0,
        y: 0,
        width: 500,
        height: 300

      })
    }

    this.setState({ chartloading: false });
    setTimeout(() => {
      this.setState({ chartloading: true });
    }, 1000);
  }


  displayLegend = () => {
    this.setState({ legendVisible: !this.state.legendVisible });
  };
  handleDialogClose = () => {
    this.setState({
      technicalnoteenable: false,
    });
  };
  handleDialogDClose = () => {
    this.setState({
      disclaimerenable: false,
    });
  };
  handleTechnicalNote = () => {
    this.setState({
      technicalnoteenable: true,
      disclaimerenable: false,
      visibleGraphPanel: false,
      popupMenuActive: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };
  handleDisclaimer = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: true,
      popupMenuActive: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };


  componentDidUpdate(prevProps, prevState) {
    window.addEventListener("resize", this.handleResize);
    if (this.state.date !== prevState.date) {

      this.setSelectedLayer(this.state.selectedMenu);

      // this.state.latlng.lat, this.state.latlng.lng
      //  this.makeChartDataAvailableDays()
    }
    if (this.state.weekselected !== prevState.weekselected) {
      this.setSelectedLayer(this.state.selectedMenu);
    }
    if (this.state.monthselected !== prevState.monthselected) {
      this.setSelectedLayer(this.state.selectedMenu);
    }
    if (this.state.geojsondata !== prevState.geojsondata) {
      //this.setGeoJson()
    }

    if (this.state.selectedMenu !== prevState.selectedMenu) {

      // this.makeChartDataAvailableDays()
    }

  }

  render() {
    console.log("DDDDDDDDDDDDDDDDDDDDDDDD",this.state.width,this.state.height )
    console.log("this.state.chartloading",this.state.chartloading,this.props.chartloading_reservoir)
    console.log(
      this.state.visibleGraphPanel &&
      layerMap[this.state.selectedMenu] !== "FSRO_1"
    );
    // console.log(this.state.visibleGraphPanel && (this.state.selectedMenu.split(" ")[0] === "Forecast"));
    let params = new URLSearchParams(this.props.location.search);
    console.log(params.get("selected"));

    let menuList = this.state.tabs.map((child) => {
      return (
        <div
          style={{
            padding: "1px",
            borderRadius: "4px",
            margin: "0px",
            backgroundColor: colors.final_side_sub,
            color:colors.textcolor,
          }}
          key={child.id}
        >
          <TreeNode
            data={child}
            // id={child.id}
            weekselected={this.state.weekselected}
            weekChange={this.weekChange}
            weekYearChange={this.weekYearChange}
            weekyears={this.state.weekyears}
            weeks={this.state.weeks}
            weekyearselected={this.state.weekyearselected}

            monthselected={this.state.monthselected}
            monthChange={this.monthChange}
            monthYearChange={this.monthYearChange}
            monthyears={this.state.monthyears}
            months={this.state.months}
            monthyearselected={this.state.monthyearselected}


            active={child.active}
            clickcount={this.state.clickcount}
            incrementCounter={this.incrementCounter}
            
            handleWeekChange={this.handleWeekChange}
            weekvalue={this.state.weekvalue}

            handleMonthChange={this.handleMonthChange}
            monthvalue={this.state.monthvalue}
            
            handleTabClick={this.handleTabClick}
            getAvailableDates_url={this.getAvailableDates_url}
            getAvailableDates_date={this.getAvailableDates_date}
            getAvailableDates={this.getAvailableDates}
            handleDateChange={this.handleDateChange}
            date={this.state.date}
            availableDates={this.state.availableDates}
            menuSelected={this.menuSelected}
            setSelectedLayer={this.setSelectedLayer}
            setSelectedMenu={this.setSelectedMenu}
            setPopupMenuSelectedStatus={this.setPopupMenuSelectedStatus}
            popupMenuActive={this.state.popupMenuActive}
            popupMenuSelected={this.state.popupMenuSelected}
            togglePopupMenuSelected={this.togglePopupMenuSelected}
            setPopupMenuStatusOnMapMenuClick={this.setPopupMenuStatusOnMapMenuClick}

            weekly={this.state.weekly}
            monthly={this.state.monthly}
            
            setPopupMenuSelectedLast={this.setPopupMenuSelectedLast}
            popupMenuSelectedLast={this.state.popupMenuSelectedLast}
            setGeoJson={this.setGeoJson}
            margin={0}
            color={colors["sidebar-main-menu"]}
            selectedLayerLink={params.get("selected")}
            toggleSelectedNodeStatus={this.toggleSelectedNodeStatus}
            disableDatePicker={this.disableDatePicker}
            selectedNodeStaus={this.state.selectedNodeStaus}
            selectedMenu={this.state.selectedMenu}
            // date={moment.isMoment(this.state.date)?this.state.date.format("DD MMMM YYYY"):moment(this.state.date,"DD-MM-YYYY").format("DD MMMM YYYY")}
            setForecastDate={this.setForeCastDate}
            setNoGraph={this.setNoGraph}
            {...this.props}
          // getAvailableDates={this.getAvailableDates.bind(this)}
          />
        </div>
      );
    });


    return (
      <div
        style={{ backgroundColor:colors.textcolor, height: "100%" }}
        ref={(ref) => {
          this._menuBlock = ref;
        }}
      >
        <AboutModal
          modal={this.props.vicmodal}
          toggle={this.props.toggle}
          title={pagecontent.title}
          bodycontent={pagecontent.bodycontent}
          link={pagecontent.link}
        />

        <Sidebar.Pushable
          as={Segment}
          style={{
            marginTop: "0px",
            backgroundColor: colors.background,
            border: "0px",
          }}
        >
          <Sidebar
            as={Menu}
            animation="slide out"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.state.visible}
            // width='wide'
            style={{
              backgroundColor: colors.sidebarBackground,
              textAlign: "right",
              width: "260px",
              padding: "0px",
              border: "0px",
              color:colors.textcolor
            }}
          >

            {this.state.layerExist === true ? (
              <div></div>
            ) : (
                <div style={{ padding: "5px", textAlign: "left" }}>
                  <Message warning>
                    <Message.Header>Data does not exist </Message.Header>
                    <p>
                      Data does not exist for the selected date. The data being
                      displayed is for the last date selected.
                  </p>
                  </Message>
                </div>
              )}
            {/* Left Side Menu      */}
            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
              >
               Hydrological Modelling Systems
              </div>
            {menuList}
            </div>


            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
              >
                Information
              </div>

              <div className="modalbox">
                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleTechnicalNote}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleDisclaimer}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>
          </Sidebar>

          <Sidebar.Pusher
            dimmed={false}
            style={{
              height: "100%",
              border: "0px",
              padding: "0px",
              margin: "0px",
            }}
          >
            {/* <Grid  columns='equal' divided inverted style={{marginLeft:"0rem", marginRight:"-2rem"}}>
                        <Grid.Row columns={1} style={{paddingTop:"1em", paddingBottom:"0em"}}>
                            <Grid.Column > */}
            <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "0px",
                border: "0px",
              }}
            >
              {/* Right Side MapView  */}
              <MapView

                chartData={this.state.chartData}
                setWeeklyData={this.setWeeklyData}
                weekyearselected={this.state.weekyearselected}
                weekselected={this.state.weekselected}

                setMonthlyData={this.setMonthlyData}
                monthyearselected={this.state.monthyearselected}
                monthselected={this.state.monthselected}

                emptyChartData={this.emptyChartData}
                units_u={this.state.units_u}
                india_states_boundary={this.state.india_states_boundary}
                setLatLng={this.setLatLng}
                latlng={this.state.latlng}
                legendVisible={this.state.legendVisible}
                displayLegend={this.displayLegend}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                pointInfo={this.state.pointInfo}
                setLegend={this.setLegend}
                legend={this.state.legend}
                selectedLayer={this.state.selectedLayer}
                togglePopupMenuSelected={this.togglePopupMenuSelected}
                popMenuSelected={this.state.popupmenuName}
                popupMenuActive={this.state.popupMenuActive}
                setPopupMenuSelectedStatus={this.setPopupMenuSelectedStatus}
                popupMenuSelectedLast={this.state.popupMenuSelectedLast}
                visibleLeft={this.state.visible}
                visibleGraphPanel={this.state.visibleGraphPanel}
                visibleGraphPanel_pie={this.state.visibleGraphPanel_pie}
                toggleVisibleGraphPanel_pie={this.toggleVisibleGraphPanel_pie}
                handleAnimationChange={this.handleAnimationChange}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                getFeatureInfo={this.getFeatureInfo}
                setGradientContent={this.setGradientContent}
                setloading_fun={this.setloading_fun}
                setStateInfo={this.setStateInfo}
                toggleShowInfo={this.toggleShowInfo}
                showInfo={this.state.showInfo}
                reservoirjson={this.state.geojsondata}
                reservoirkey={this.state.reservoirkey}
                showInfoOnMapClick={this.showInfoOnMapClick}
                activeDate={
                  moment.isMoment(this.state.date)
                    ? this.state.date.format("DD MMMM YYYY")
                    : moment(this.state.date, "DD-MM-YYYY").format(
                      "DD MMMM YYYY"
                    )
                }
                noGraph={this.state.noGraph}
                // position={this.state.popup.position}
                r_chartdata={this.state.rchartData}
                reservoirname={this.state.reservoirname}
                makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                onClickDetails={{ ...this.state.onClickDetails }}
                setOnClickDetails={this.setOnClickDetails}
                stateInfo={
                  this.state.stateInfo
                    ? {
                      key: this.state.stateInfo.id,
                      geojson: { ...this.state.stateInfo },
                    }
                    : null
                }
                datesloading={this.state.datesloading}
                selectedMenu={this.state.selected}
                sliderOptions={{
                  onClickSlideLeft: this.onClickSlideLeft,
                  onClickSlideRight: this.onClickSlideRight,
                  onSlide: this.onSlide,
                  slideTracker: this.state.slideTracker,
                  max: this.state.availableDates.length - 1,
                  date: moment(this.state.date, "DD-MM-YYYY").format(
                    "D MMM YYYY")
                }}
                wms_url_base_layers={this.state.wms_url_base_layers}
              // setSelectedMainMenu={this.setSelectedMainMenu}
              // selectedMainMenu={this.state.selectedMainMenu}
              />
            </Segment>

            {this.state.technicalnoteenable || this.state.disclaimerenable ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.technicalnoteenable ? (
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogClose}
                      ></div>
                      Technical Note
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      {/* <div>
                        <Document
                          file={this.state.pdffile}
                          onLoadSuccess={this.onDocumentLoadSuccess}
                        >
                          <Page pageNumber={this.state.pageNumber} />
                        </Document>
                        <p>Page {this.state.pageNumber} of {this.state.numPages}</p>
                      </div> */}
                      {/* <Document
                        file={this.state.pdffile}
                      //  onLoadSuccess={this.onDocumentLoadSuccess}
                      >
                        <Page pageNumber={pageNumber} width={600} />
                      </Document> */}
                      <div class="dialog_content">

                        <p ><span style={{ color: "blue" }}>Hydrological Modeling</span></p>
                        <p align="justify">
                          Under National Hydrology Project (NHP), National level hydrological modelling framework is established using Variable Infiltration Capacity (VIC-3L) model using Geo-spatial datasets (LULC, Soil, and DEM) and meteorological datasets (Rainfall, Temperature). VIC is a macro-scale, process based, semi-distributed & physically based hydrological model, solves both the water balance and the energy balance (Liang X., 1994). The established modelling framework computes evapotranspiration, surface runoff, soil moisture, base flow and energy fluxes on a daily basis for entire India at 5.5 km grid resolution.
</p>
                        <p align="justify">
                          Model computed WBCsare translated into various value added products: (1) Inflow into major reservoirs of India for past and future time step (2) Drought indicators like Standardized Runoff Index (SRI) and Soil Moisture Availability Index (SMAI) to represent dryness and wetness (3) Crop-specific Irrigation requirement (to be updated soon).
</p>
                        <p align="justify"><span style={{ color: "blue" }}>
                          Input datasets Used</span>:</p>

                        <p align="justify"> <span style={{ color: "blue" }} >Land Use Land Cover (LULC) </span>:VIC-3L explicitly represents sub-grid heterogeneity in land cover classes taking their phonological changes into account such as their leaf area index (MODIS – LAI; MCD15A2), Albedo (MODIS - MCD43A3), canopy resistance, and relative fraction of roots in each of the soil layers. Land use/Land cover (LULC) data generated under Natural Resources Census (NRC) at 56m spatialresolution (NRSC, 2015) is used for vegetation parameter representation. (https://bhuvan-app3.nrsc.gov.in/data/download/index.php)</p>
                        <p align="justify"> <span style={{ color: "blue" }} >
                          Digital Elevation Model (DEM)</span>:ASTER 90m DEM (https://earthexplorer.usgs.gov/)</p>
                        <p align="justify"> <span style={{ color: "blue" }} >
                          Soil Map </span>:National Bureau of Soil Survey and Land Use Planning (NBSS&LUP) 1:50,000-scale soil map was used to define soil textural information. Using surface texture, particle size and soil depth information, three soil layers of 0.15 m, 0.35 m and 1 m have been considered as soil depth in the modeling framework. The basic soil information extracted was used to determine soil hydraulic properties using pedo-transfer function (Saxton and Rawls 1982). The model handles the subsurface into multiple soil layers. Each layer characterizes soil hydrological response such as bulk density, infiltration capacity, saturated hydraulic conductivity, soil layer depths, and soil moisture diffusion parameters. (https://www.nbsslup.in/)
</p>
                        <p align="justify"> <span style={{ color: "blue" }} >
                          Meteorological Datasets</span>:India Meteorological Department (IMD) gridded daily precipitation (0.25 degree) and Maximum/Minimum Temperature (0.5 degree) data are used for daily hydrological model computations. (https://imdpune.gov.in/Seasons/Temperature/temp.html)
</p>
                        <p align="justify"> <span style={{ color: "blue" }} >Model Calibration and Validation</span>:

                        Model simulated discharge is calibrated basin wise for the period 1976 to 1985 using CWC field discharge data. Nash–Sutcliffe efficiency (NSE; Nash and Sutcliffe, 1970) was used as the model performance index. State variables like Soil Moisture and Evapotranspiration are validated using IMD in-situ soil moisture data (limited) and MODIS ET product respectively.
</p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          About Product</span>:</p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Water Balance Components</span>:Daily Water Balance Components (WBCs) are available at national level from 1st of Jan 1981 to till date. Water  Balance  Components  (WBCs)  estimated  at  grid  level  for  a  day  is  represented  spatially at 5.5km grid level. </p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Surface runoff</span>: Surface runoff product depicts the simulated surface runoff in depth (mm) units at each grid (3min/5.5 km).</p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Soil Moisture</span>: Profile Soil Moisture is simulated at three soil depths (0 – 15 cm; 15 – 50 cm; 50 – 150 cm). Soil moisture products represents grid-wise (3min/~5.5 km) simulated soil moisture in volume units (m3/m3) for the above three layers and 0-50cm layer.</p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Evapotranspiration</span>: ET product depicts the simulated evapotranspiration in depth (mm) units at each grid (3min/5.5 km).</p>
                        <p align="justify"><span style={{ color: "blue" }} >

                          Forecast Surface Runoff</span>: Forecast surface runoff is presented for three successive days (d+1, d+2, d+3, where d = Current Day) using open source weather forecast data (Global Ensemble Forecast System–GEFS; IMD–WRF, etc). Forecasted surface runoff product depicts the likely surface runoff depth (mm) at each grid.</p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Inflows into Major Reservoirs</span>:The model computed surface runoff and base flow are routed through the stream network for independent/total catchment of reservoir. Inflowsare estimated for 150 major reservoirs of India for past and future three day lead time step.

<p align='justify'>Independent catchment:It is defined as the independent area draining into the reservoir (from its own catchment) without any abstraction in form of lakes farm ponds and water bodies.</p>

                          <p align='justify'>Total catchment:It is defined as the total area draining into the reservoir (from its total catchment) without any abstraction in form of lakes farm ponds and water bodies.The inflows contributing to the reservoir is from its own catchment as well as from intercepted catchment, without considering the cascade effects of reservoirs.</p>

                          <p align='justify'>Abstracted flows: It is defined as the total area draining into the reservoir (from its own catchment) consideringupstream abstraction.The inflows contributing to the reservoir is from its own catchment as well as from intercepted catchment, with the consideration of cascade effects of major reservoirs only. Reservoirs standard operating rule curves are adopted to capture the reservoir dynamics.</p></p>


                        {/* Inflows into Major ReservoirsThe model computed surface runoff and base flow are routed through the stream network for independent catchment of reservoir.Natural flows (intervention free) are estimated for 91 major reservoirs of India for three day lead time step considering the standard operating rule curve. </p> */}
                        <p align="justify"><span style={{ color: "blue" }} >
                          Limitation in the current modeling framework</span>:
<ul><li>
                            Model computed hydrological fluxes are driven by only rainfall, therefore model simulated soil moisture and evapotranspiration are devoid of any supplementary supplies in the form of irrigation. </li>
                            <li>Model computations consider static LULC for estimation of water balance components. </li>
                          </ul>
                        </p>
                        <p align="justify"><span style={{ color: "blue" }} >
                          Utility of Product</span>:

                          Hydrological fluxes are useful for quantifying spatial and temporal variation in basin/sub-basin scale surface runoff, to study water resources availability, useful for water resources management, drought/flood assessment and climate related research.These productshave vast scope in hydrological, agricultural and atmospheric applications domain.
</p>
                        <br />
                        <br />
                        <br />






                      </div>

                    </div>
                    {/* 
    <div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : this.state.disclaimerenable ? (
                  <div id="divDialog" class="dialog boxshadow"  >
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogDClose}
                      ></div>
                      Disclaimer
                    </div>
                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content" >
                        <p align="justify">
                          The hydrological products hosted are experimental in nature and requires validation with field data. NRSC does not guarantee the accuracy of information provided and accepts no responsibility or liability for any consequences arising from the use of such data.NRSC uses several open data resources to derive and publishing hydrological products through this website. Neither NRSC nor any other party involved in creating, producing or delivering the product through this website shall be liable for any direct, incidental, consequential, indirect or punitive damages arising out of Users' access to, or use of, the website and the products. User feedback on any errors or inaccuracies will be highly appreciated.
                    </p>
                        <br />
                        <br />
                      </div>
                    </div>
                    {/* 
    <div class="dialog-statusbar">Ready</div> */}
                  </div>
                ) : (
                      <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.chartloading}
                        />
                      </div>
                    )}
              </Rnd>
            ) : null}

            {this.state.popupmenuName === "Hydrological Science" &&
              this.state.popupMenuActive ? (
                <Rnd
                  style={{ zIndex: "200", background: "white" }}
                  size={{
                    width: this.state.width_p,
                    height: this.state.height_p,
                  }}
                  position={{ x: this.state.x_p, y: this.state.y_p }}
                  onDragStop={(e, d) => {
                    this.setState({ x_p: d.x_p, y_p: d.y_p });
                  }}
                >
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.setPopupMenuSelectedStatus}
                      ></div>
                      Hydrological Modelling System
                     </div>

                    <div class="dialog_content">{ReactHTMLParser(message123)}</div>
                  </div>
                </Rnd>
              ) : null}

            {this.state.visibleGraphPanel && this.state.selectedMenu.split("-")[0] !== 'smai' ? (
              <Rnd className="vic_ccharts"
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                // size={{ width: this.state.width, height: this.getChartHeight(this.state.selectedMenu) }}
                // position={{ x: this.state.x, y: this.getChartY(this.state.selectedMenu) }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
             
             {this.state.chartloading ? (
  <div className="sweet-loading">
    <FadeLoader
      sizeUnit={"px"}
      color={"#123abc"}
      loading={this.state.chartloading}
    />
  </div>
) : this.state.rchartData !== null ? (
  <GraphOptionsBox
    rname={this.state.reservoirname}
    data={this.state.rchartData}
    curr_date={this.state.reservoir_date}
    flow_hist={this.state.flow_hist}
    dates_hist={this.state.dates_hist}
    month_monthlyAvg={this.state.month_monthlyAvg}
    flow_monthlyAvg={this.state.flow_monthlyAvg}
    dates_dailyAvg={this.state.dates_dailyAvg}
    month_dailyAvg={this.state.month_dailyAvg}
    flow_dailyAvg={this.state.flow_dailyAvg}
    prob_flowDur={this.state.prob_flowDur}
    flow_flowDur={this.state.flow_flowDur}
    year_returnPer={this.state.year_returnPer}
    flow_returnPer={this.state.flow_returnPer}
    reservoirHistname={this.state.reservoirHistname}
    reservoirLongMonthname={this.state.reservoirLongMonthname}
    reservoirLongdailyname={this.state.reservoirLongdailyname}
    reservoirFlowname={this.state.reservoirFlowname}
    date={this.state.date}
    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
  />
) : (this.state.chartData !== null && this.state.selectedMenu.split("-")[0] !== 'Soil Moisture') ? (
               
                  <Chart
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) : (this.state.chartData !== null && this.state.selectedMenu.split("-")[0] === 'Soil Moisture')? (
               
                  <CChart_SM
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) :
                    this.state.weekseries !== null && this.state.weekseries.length > 0 ?
                      <BarChart
                      title={this.state.smaititle}
                        labels={this.state.weeklabels}
                        data={this.state.weekseries}
                        categories={this.state.weekcategories}
                        toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                        vertical={this.state.vertical}
                      /> :
                      this.state.monthseries !== null && this.state.monthseries.length > 0 ?
                        <BarChart
                        title={this.state.smaititle}
                          labels={this.state.monthlabels}
                          data={this.state.monthseries}
                          categories={this.state.monthcategories}
                          toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                          vertical={this.state.vertical}
                        /> : (
                        <div className="sweet-loading">
                          <FadeLoader
                            // css={override}
                            sizeUnit={"px"}
                            // size={150}
                            color={"#123abc"}
                            loading={this.state.chartloading}
                          />
                        </div>
                      )}
              </Rnd>
            ): this.state.visibleGraphPanel && this.state.selectedMenu.split("-")[0] === 'smai' ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height_smai }}
                position={{ x: this.state.x, y: this.state.y_smai }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y_smai: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height_smai: ref.style.height,
                    ...position,
                  });
                }}
              >       
              

                {(this.state.chartData !== null && this.state.selectedMenu.split("-")[0] !== 'Soil Moisture') ? (
               
                  <Chart
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) : (this.state.chartData !== null && this.state.selectedMenu.split("-")[0] === 'Soil Moisture')? (
               
                  <CChart_SM
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) :
                    this.state.weekseries !== null && this.state.weekseries.length > 0 ?
                      <BarChart
                      title={this.state.smaititle}
                        labels={this.state.weeklabels}
                        data={this.state.weekseries}
                        categories={this.state.weekcategories}
                        toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                        vertical={this.state.vertical}
                      /> :
                      this.state.monthseries !== null && this.state.monthseries.length > 0 ?
                        <BarChart
                        title={this.state.smaititle}
                          labels={this.state.monthlabels}
                          data={this.state.monthseries}
                          categories={this.state.monthcategories}
                          toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                          vertical={this.state.vertical}
                        /> : (
                        <div className="sweet-loading">
                          <FadeLoader
                            // css={override}
                            sizeUnit={"px"}
                            // size={150}
                            color={"#123abc"}
                            loading={this.state.chartloading}
                          />
                        </div>
                      )}
              </Rnd>
            ) : null}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default MapContainer;
